import React from 'react';
import './Vision.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const Vision = () => {
  return (
    <div className="vision-page" id="ruk-vision-page">
      <Navbar />
      
      <div className="vision-container" id="ruk-vision-container">
        <div className="page-header" id="ruk-page-header">
          <h1>Vision & Mission</h1>
          <div className="header-underline" id="ruk-header-underline"></div>
        </div>
        
        <div className="vision-mission-content" id="ruk-vision-mission-content">
          {/* Main Layout with Logo on Left and Content on Right */}
          <div className="main-layout" id="ruk-main-layout">
            
            <div className="content-section" id="ruk-content-section">
              {/* Vision Section */}
              <div className="vision-section" id="ruk-vision-section">
                
                <div className="vision-text" id="ruk-vision-text">
                  <h2>VISION</h2>
                  <p>
                    To achieve national distinction for creativity, innovation and excellence, through quality teaching, 
                    research in higher education, with inclusiveness, social equilibrium and contribute to the building 
                    of a humane, scientific and progressive society.
                  </p>
                </div>
              </div>
              
              <div className="divider" id="ruk-divider-1"></div>
              
              {/* Mission Section */}
              <div className="mission-section" id="ruk-mission-section">
                
                <div className="mission-text" id="ruk-mission-text">
                  <h2>MISSION</h2>
                  <div className="mission-points" id="ruk-mission-points">
                    <div className="mission-point" id="ruk-mission-point-1">
                      <div className="point-number">1</div>
                      <div className="point-content">
                        <p>
                          To provide an educational environment where students can realize their full potential in their 
                          chosen discipline and attain quality education to face the challenges of the future.
                        </p>
                      </div>
                    </div>
                    
                    <div className="mission-point" id="ruk-mission-point-2">
                      <div className="point-number">2</div>
                      <div className="point-content">
                        <p>
                          To implement a variety of high-quality programs at undergraduate, postgraduate, and doctoral 
                          levels for all specializations and disciplines.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="divider" id="ruk-divider-2"></div>
              
              {/* Core Values Section */}
              <div className="core-values-section" id="ruk-core-values-section">
                <h2>CORE VALUES</h2>
                <div className="values-grid" id="ruk-values-grid">
                  <div className="value-card" id="ruk-value-card-1">
                    <h3>Integrity and Ethics</h3>
                    <p>
                      Rayalaseema University emphasizes honesty, transparency, and ethical conduct in all activities, 
                      including academic work, research, and interactions with others.
                    </p>
                  </div>
                  
                  <div className="value-card" id="ruk-value-card-2">
                    <h3>Respect</h3>
                    <p>
                      University promotes a culture of inclusivity, where all members of the community are treated 
                      with dignity and fairness, regardless of background or beliefs.
                    </p>
                  </div>
                  
                  <div className="value-card" id="ruk-value-card-3">
                    <h3>Responsibility</h3>
                    <p>
                      University instils a sense of responsibility in students and faculty, encouraging them to be 
                      accountable for their actions and to contribute positively to society.
                    </p>
                  </div>
                  
                  <div className="value-card" id="ruk-value-card-4">
                    <h3>Excellence</h3>
                    <p>
                      A commitment to high standards of teaching, learning, and research is central to a university's 
                      mission. This includes striving for continuous improvement and innovation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Vision;